import { FieldViewModel, LayerTypeId } from "../../omnia"
import { IFieldsService } from "../../types"

export function includeCroppingLayer(field: FieldViewModel) {

    if (!field) return false
    if (!field.isField()) return false

    return getCroppingSplits(field).length > 1

}


export function createHoldingCroppingLayer(fieldSvc: IFieldsService) {

    const cropping = fieldSvc.cropping.filter(c => c.currentYear).map(c => c.cropping)
    const year = fieldSvc.yearId

    return {

        visible: false,
        zonesLoaded: true,

        get croppingList() {
            return cropping
        },

        get type() {
            return null
        },

        checkTypeId(typeId: LayerTypeId): boolean {
            return false
        },

        getLayerDescription(): string {
            return `(${year} cropping)`;
        }

    }



}

export function createCroppingLayer(field: FieldViewModel) {

    const splits = getCroppingSplits(field)

    return {

        visible: false,
        zonesLoaded: true,

        get field() {
            return field
        },

        get croppingList() {
            return splits
        },

        get type() {
            return null
        },

        checkTypeId(typeId: LayerTypeId): boolean {
            return false
        },

        getLayerDescription(): string {
            return `(Cropping for field '${field.fieldName}')`
        }

    }


}

function getCroppingSplits(field: FieldViewModel) {

    const splits = field.croppings
        .filter(c => c.currentYear)
        .filter(c => c.cropping.NextCroppings.every(n => n.YearId > c.cropping.YearId))
        .map(c => c.cropping)

    return splits

}
